// extracted by mini-css-extract-plugin
module.exports = {"main-container":"parameters__main-container___3x1tU","mainContainer":"parameters__main-container___3x1tU"};